module.exports = {render: function () {with(this){return _c('svg',{staticClass:"arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.4 18.66"}},[_c('title',[_v("Artboard 2")]),_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-width":"2","d":"M8.7 17.16V0M16.4 9.33l-7.7 7.83L1 9.33"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-svg-loader!./static/images/arrow.svg
// module id = 12
// module chunks = 1